import axios, { AxiosResponse } from "axios";
import { ContainerType } from "@Base/Engagement/ContainerType";
import { EngagementService } from "@Api/EngagementService";
import { RecommendationBase } from "@Base/Engagement/RecommendationBase";
import { Tenant } from "@Utilities/Tenant";
import { forEachBail } from "enhanced-resolve";
export class MalachyteRecommendation extends RecommendationBase
{
	private readonly engagementService: EngagementService;

	constructor()
	{
		super();
		this.engagementService = new EngagementService();
	}

	public GetRecommendations = (requests: RecommendationRequest[]): void =>
	{
		if (requests && Array.isArray(requests) && requests.length > 0)
		{
			let exclusions: string[] = [];
			const productsToExclude = document.getElementsByClassName("exclude-product");
			const utmParameter = "malachtye";

			for (var i = 0; i < productsToExclude.length; i++)
			{
				exclusions.push(productsToExclude[i].textContent);
			}

			let containerRequests: ContainerRequest[] = [];
			for (var i = 0; i < requests.length; i++)
			{
				if (requests[i].ResultCount)
				{
					const containerRequest: ContainerRequest = {
						ExcludedProductIds: exclusions,
						ProductId: requests[i].ProductId,
						ResultCount: requests[i].ResultCount,
						Strategy: requests[i].Strategy
					};

					containerRequests.push(containerRequest);
				}
			}

			this.engagementService.GetRecommendations(containerRequests)
				.then((response: string) =>
				{
					if (response && response.length > 0)
					{
						let resultList = [];
						const result = JSON.parse(response);

						if (Array.isArray(result))
						{
							resultList = result;
						}
						else
						{
							resultList.push(result);
						}

						const recommendationList = this.HydrateRecommendations(resultList, utmParameter);

						for (var i = 0; i < resultList.length; i++)
						{
							const recommendations = recommendationList[resultList[i].strategy_name];
							const title = this.KebabToTitleCase(resultList[i].strategy_name);

							let containerType: string = "";
							let divName: string = "";

							for (var j = 0; j < requests.length; j++)
							{
								if (resultList[i].strategy_name === requests[j].Strategy)
								{
									containerType = requests[j].ContainerType;
									divName = requests[j].DivName;
								}
							}

							switch (Tenant.Type)
							{
								case "HC":
								case "HW":
									if (containerType === ContainerType.HCProductCard)
									{
										this.RenderHCProductCard(divName, title, recommendations, utmParameter);
									}
									else if (containerType === ContainerType.HCHoverRecs)
									{
										this.RenderHCHoverRecs(divName, title, recommendations);
									}
									break;
								case "Fun":
									if (containerType === ContainerType.FunProductCard)
									{
										this.RenderFunProductCard(divName, title, recommendations, utmParameter);
									}
									else if (containerType === ContainerType.RecentlyViewedSide)
									{
										this.RenderRecentlyViewedSide(divName, recommendations);
									}
									break;
								default:
									break;
							}
						}
					};
				})
				.catch((error) =>
				{
					console.log(error);
				});;
		}
	};

	private KebabToTitleCase = (str: string): string =>
	{
		return str
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	};
}

export interface RecommendationRequest
{
	ContainerType: string,
	DivName: string,
	ProductId: string,
	ResultCount: number,
	Strategy: string
}
export interface ContainerRequest
{
	ExcludedProductIds: string[],
	ProductId: string,
	ResultCount: number,
	Strategy: string
}